import { useMutation, useQueryClient } from 'react-query';
import { loan_quote_accept_api } from '@axo/shared/data-access/api';
import { applicationKeys } from '../cache-keys/applicationKeys';
import { loan_application, loan_quote } from '@axo/shared/data-access/types';
import { useAPI } from '@axo/shared/data-access/provider';
import { useLoanQuotePresentation } from '../queries/useLoanQuotePresentation';

export function useAcceptQuote(
  application: loan_application.LoanApplication,
  quoteID: string,
) {
  const client = useQueryClient();
  const api = useAPI();
  const { data: loanQuotePresentationData } = useLoanQuotePresentation(
    application.ID,
  );

  return useMutation(
    ({
      AcceptableQuoteIndex,
      ...input
    }: Omit<loan_quote.AcceptQuoteInput, 'MarketCountry'> & {
      AcceptableQuoteIndex?: number;
    }) =>
      loan_quote_accept_api.createLoanQuoteAccept(api.url.service, api.token, {
        LoanQuoteID: quoteID,
        LoanApplicationID: application.ID,
        CustomerID: application.CustomerID,
        PersonID: application.PersonID,
        AcceptableQuoteIndex,
        NumPreviouslyAcceptedQuotes:
          loanQuotePresentationData?.AcceptedLoanQuotes.length ?? 0,
        AcceptQuoteInput: {
          ...input,
          MarketCountry: application.MarketCountry,
        },
      }),
    {
      onSuccess: () =>
        client.invalidateQueries(
          applicationKeys.loanQuotes({
            applicationID: application.ID,
          }),
        ),
    },
  );
}
